import type { TFunction } from 'i18next';
import * as yup from 'yup';
import { ValidationError } from 'yup';

export type InvoicePayerEmailsInput = {
  payerEmails: string[];
};

export function buildInvoicePayerEmailsSchema(t: TFunction) {
  return yup.object().shape({
    payerEmails: yup.array().of(yup.string().trim().email(t('errors.email'))),
  });
}

/**
 * Validates payer email rows: trims, drops empty slots; each entered address must be valid (all empty is OK).
 * @throws {ValidationError} with i18n messages from `errors.email` or checkout keys
 */
export function validateInvoicePayerEmails(
  rows: string[],
  t: TFunction,
): string[] {
  const trimmed = rows.map((s) => s.trim()).filter(Boolean);
  const schema = buildInvoicePayerEmailsSchema(t);
  schema.validateSync({ payerEmails: trimmed });
  return trimmed;
}

export function isYupValidationError(err: unknown): err is ValidationError {
  return ValidationError.isError(err);
}
